module.exports = __webpack_public_path__ + "img/old_1.c684dc8c.jpg";